<template>
  <div class="card-list-body">
    <div
      v-for="item in list"
      :key="item.cardId"
      class="list-item"
    >
      <card-res :feed="item" :is-design="isDesign" />
    </div>
  </div>
</template>

<script>
import CardRes from '@/components/Card/CardRes';
import { CONFIG } from '@/utils/env';

export default {
  name: 'ResourceList',

  components: {
    CardRes
  },

  props: {
    list: {
      type: Array,
      default: () => ([])
    }
  },

  computed: {
    isDesign() {
      return !!(this.$route.params.boardKey === CONFIG.NRZ.DESIGN_CARD_NO.toString());
    }
  }
};
</script>
